import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HorizontalLayout from "../../../utils/home/horizontal_layout";
import tournamentIcon from "../../../assets/teamicon.png";
import { FaTrophy } from "react-icons/fa";

const TournamentsTab = ({ team, selectedSubcategory }) => {
  const token = useSelector((state) => state.user.token);
  const [tournaments, setTournaments] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const response = await fetch(
          `https://server-postgre.vercel.app/api/teams/${team.id}/tournaments?categoryId=${selectedSubcategory}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error al obtener los torneos del equipo");
        }

        const data = await response.json();
        setTournaments(data);
      } catch (error) {
        setError(error.message);
      }
    };
    if (selectedSubcategory) {
      fetchTournaments();
    }
  }, [team.id, selectedSubcategory, token]);

  if (error)
    return <p className="text-red-500 text-center font-semibold">{error}</p>;

  // Adaptar los datos de los torneos para HorizontalLayout
  const tournamentItems = tournaments.map((tournament) => ({
    id: tournament.id,
    imageSrc: tournament.picture_url || <FaTrophy />,
    columnTitle: tournament.tournament_name,
    text1: `Categoría: ${tournament.tournament_type}`,
    text2: `Edición: ${tournament.edition}`,
  }));

  return (
    <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl shadow-lg p-6 space-y-6">
      {/* Header con icono */}
      <div className="flex items-center justify-center gap-3 text-emerald-600">
        <FaTrophy className="text-2xl" />
        <h2 className="text-xl font-bold">Torneos del Equipo</h2>
      </div>

      {/* Lista de torneos */}
      {tournaments.length === 0 ? (
        <p className="text-center text-gray-500">
          No hay torneos registrados para este equipo.
        </p>
      ) : (
        <HorizontalLayout
          title="Torneos"
          items={tournamentItems}
          basePath="tournaments"
        />
      )}
    </div>
  );
};

export default TournamentsTab;
